/** Choose between Facebook Embedded Signup (recommended) or manual API credentials. */
const ConnectMethodPicker = ({ open, onClose, onSelectFacebook, onSelectManual }) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[9998] flex items-center justify-center bg-black/50 backdrop-blur-sm p-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg overflow-hidden">
        <div className="px-6 py-5 border-b border-gray-200">
          <h2 className="text-lg font-bold text-gray-900">Add WhatsApp Number</h2>
          <p className="text-sm text-gray-600 mt-1">
            Choose how you want to connect your WhatsApp Business number.
          </p>
        </div>

        <div className="p-6 space-y-3">
          <button
            type="button"
            onClick={() => {
              onClose();
              onSelectFacebook();
            }}
            className="w-full text-left rounded-xl border-2 p-4 hover:shadow-md transition-all"
            style={{ backgroundColor: "#E7F3FF", borderColor: "#0064E0" }}
          >
            <div className="flex items-start gap-3">
              <div className="w-10 h-10 rounded-xl flex items-center justify-center border border-gray-300 bg-white flex-shrink-0">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                </svg>
              </div>
              <div>
                <div className="flex items-center gap-2">
                  <span className="font-bold text-gray-900">Connect with Facebook</span>
                  <span className="text-[10px] uppercase tracking-wide font-bold px-2 py-0.5 rounded-full bg-emerald-100 text-emerald-700">
                    Recommended
                  </span>
                </div>
                <p className="text-sm text-gray-600 mt-1">
                  Guided signup — Meta handles token, phone register, and webhooks automatically.
                </p>
              </div>
            </div>
          </button>

          <button
            type="button"
            onClick={() => {
              onClose();
              onSelectManual();
            }}
            className="w-full text-left rounded-2xl border border-gray-200 p-4 hover:bg-gray-50 hover:border-gray-300 transition-all bg-white"
          >
            <div className="flex items-start gap-3">
              <div className="w-10 h-10 rounded-xl flex items-center justify-center border border-gray-200 bg-gray-50 flex-shrink-0">
                <svg className="w-5 h-5 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                </svg>
              </div>
              <div>
                <span className="font-bold text-gray-900">Connect Manually</span>
                <p className="text-sm text-gray-600 mt-1">
                  Use WABA ID, Phone ID & access token — we verify with Meta and activate on Blutec Ping.
                </p>
              </div>
            </div>
          </button>
        </div>

        <div className="px-6 pb-5">
          <button
            type="button"
            onClick={onClose}
            className="w-full py-2.5 rounded-xl border border-gray-300 text-sm font-semibold text-gray-700 hover:bg-gray-50"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConnectMethodPicker;
